import { Injectable } from '@angular/core';
import { CapacitorSQLite, SQLiteDBConnection, SQLiteConnection } from '@capacitor-community/sqlite';
import {Constants} from "../models/constants";


@Injectable({
  providedIn: 'root'
})
export class SqLiteService {
  private sqlite: SQLiteConnection = new SQLiteConnection(CapacitorSQLite);
  public db!: SQLiteDBConnection;
  public user_id: number;

  platform: string;

  constructor() {

  }

  async createTables() {
    console.log('createTables');
    const sqlite_category_schema = `CREATE TABLE IF NOT EXISTS 'category' (
      id             integer primary key,
      user_id        integer,
      Amount         integer,
      category_refID integer,
      color          text,
      created_at     text,
      parent_cid     integer,
      description    text,
      icon           text,
      picture        text,
      name           text,
      type           integer,
      updated_at     text
    )`;
    await this.db.execute(sqlite_category_schema).finally(() => {
      console.log('createTables: category');
    });

    const sqlite_item_schema = `CREATE TABLE IF NOT EXISTS 'edoc' (
      id                 integer primary key,
      user_id            integer,
      Amount             integer,
      categories         text,
      color              text,
      component_features text,
      created_at         text,
      dbalias            text,
      description        text,
      email_text         text,
      features           text,
      hidden_fields      text,
      icon               text,
      picture            text,
      index_fields       text,
      key_fields         text,
      maxAmount          integer,
      ref_edoc_id        integer,
      status             integer,
      type               integer,
      update_fields      text,
      updated_at         text
    )`;
    await this.db.execute(sqlite_item_schema).finally(() => {
      console.log('createTables: edoc');
    });

    const sqlite_edoc_details_schema = `CREATE TABLE IF NOT EXISTS 'edoc_details' (
      id                 integer primary key,
      user_id            integer,
      edoc_data_id       integer,
      edoc_id            integer,
      user_email         text,
      created_at         text,
      updated_at         text
    )`;
    await this.db.execute(sqlite_edoc_details_schema).finally(() => {
      console.log('createTables: edoc_details');
    });
  }

  async initializePlugin(): Promise<void> {

    const ret = await this.sqlite.checkConnectionsConsistency();
    console.groupCollapsed("checkConnectionsConsistency");
    console.log(ret);
    console.log(this.db);
    console.groupEnd();

    if (!this.db) {
      this.db = await this.sqlite.createConnection("murimed_elearning.sqlite", false, "no-encryption", 1, false);
    }

    await this.db.open();

    await this.createTables();
  }



  private getUserId() {
    console.log('getUserId', localStorage.getItem(Constants.USERID));



    if (typeof this.user_id === 'undefined') {
      this.user_id = parseInt(localStorage.getItem(Constants.USERID));
    }
    return this.user_id;
  }

  async clearDatabase() {
    await this.deleteTable('category', this.user_id);
    await this.deleteTable('edoc', this.user_id);
    await this.deleteTable('edoc_details', this.user_id);

    return true;
  }

  async insertCategory(data: Object)
  {
    await this.deleteById('category', data['id']);

    const query = `INSERT OR IGNORE INTO 'category' (user_id, Amount, category_refID, color, created_at, parent_cid, description, picture, icon, id, name, type, updated_at)
                    VALUES ('${this.user_id}', '${data['Amount']}', '${data['category_refID']}', '${data['color']}', '${data['created_at']}', '${data['parent_cid']}', '${data['description']}', '${data['picture']}', '${data['icon']}', '${data['id']}', '${data['name']}', '${data['type']}', '${data['updated_at']}');`;

    const result = await this.db.query(query);
    return result;
  }


  async insertEdoc(data: Object)
  {
    await this.deleteById('edoc', data['id']);

    const query = `INSERT OR IGNORE INTO 'edoc' (user_id, Amount, categories, color, component_features, created_at, dbalias, description, email_text, features,
                  hidden_fields, picture, icon, id, index_fields, key_fields, maxAmount, ref_edoc_id, status, type,
                  update_fields, updated_at)
                    VALUES ('${this.user_id}', '${data['Amount']}', '${data['categories']}', '${data['color']}', '${data['component_features']}', '${data['created_at']}',
                    '${data['dbalias']}', '${data['description']}', '${data['email_text']}', '${data['features']}', '${data['hidden_fields']}',
                     '${data['picture']}', '${data['icon']}', '${data['id']}', '${data['index_fields']}', '${data['key_fields']}', '${data['maxAmount']}', '${data['ref_edoc_id']}',
                     '${data['status']}', '${data['type']}', '${data['update_fields']}','${data['updated_at']}');`;

    const result = await this.db.query(query);
    return result;
  }

  async insertEdocDetails(data: Object)
  {
    await this.deleteById('edoc_details', data['id']);

    const query = `INSERT OR IGNORE INTO 'edoc_details' (id, user_id, edoc_data_id, edoc_id, user_id, user_email, created_at, updated_at)
                    VALUES ('${data['id']}', '${this.user_id}', '${data['edoc_data_id']}', '${data['edoc_id']}', '${data['user_id']}', '${data['user_email']}', '${data['created_at']}', '${data['updated_at']}');`;

    const result = await this.db.query(query);
    return result;
  }


  /**
   * Deletes all records from the specified table in the database.
   *
   * @param {string} table - The name of the table to delete records from.
   * @param {number} [user_id=0] - The ID of the user whose records should be deleted. Defaults to 0, which means all records are deleted.
   * @return {Promise<any>} A promise that resolves to the result of the delete operation.
   */
  async deleteTable(table: string, user_id: number = 0) {
    // Build the query to delete all records from the specified table
    let query = `DELETE FROM ${table};`;

    // If a user ID is provided, only delete records for that user
    if (user_id != 0) {
      query = `DELETE FROM ${table} WHERE user_id = ${user_id};`;
    }

    const result = await this.db.query(query);
    return result;
  }


  /**
   * Deletes a record from the specified table by its ID.
   *
   * @param {string} table - The name of the table from which the record should be deleted.
   * @param {number} id - The ID of the record to be deleted.
   * @return {Promise<any>} A promise that resolves with the result of the delete operation.
   */
  async deleteById(table: string, id: number) {
    const query = `DELETE FROM ${table} WHERE id = ${id};`;
    const result = await this.db.query(query);

    return result;
  }


  /**
   * Retrieves a list of categories based on the specified parent category ID.
   *
   * @param {number} parent_id - The ID of the parent category whose child categories are to be retrieved.
   * @param {string} [orderBy='description ASC'] - The column by which the results should be ordered. Defaults to 'description ASC'.
   * @param {number} [user_id=0] - The ID of the user for whom the categories are fetched. Defaults to 0, which is replaced internally with a class-level user ID.
   * @return {Promise<Array>} A promise that resolves to an array of category records matching the criteria.
   */
  async getCategoriesByParentId(parent_id: number, orderBy: string = 'description ASC', user_id: number = 0)
  {
    if (user_id == 0) user_id = this.getUserId();

    const query = `SELECT * FROM category WHERE parent_cid = ${parent_id} AND user_id = ${user_id} ORDER BY ${orderBy};`; // WHERE category_refID = ${parent_id}
    const result = await this.db.query(query);

    return result;
  }


  /**
   * Retrieves electronic documents (eDocs) filtered by a given category ID.
   *
   * @param {number} category_id - The ID of the category to filter eDocs by.
   * @param {string} [orderBy='description ASC'] - The order in which to sort the results. Defaults to 'description ASC'.
   * @param {number} [user_id=0] - The ID of the user to filter documents for. If not provided, defaults to the user's ID.
   * @return {Promise<any[]>} A promise that resolves to an array of eDocs matching the filter criteria.
   */
  async geteDocsByCategoryId(category_id: number, orderBy: string = 'description ASC', user_id: number = 0)
  {
    if (user_id == 0) user_id = this.getUserId();

    const query = `SELECT * FROM edoc WHERE categories LIKE '%"${category_id}"%' AND user_id = ${user_id} ORDER BY ${orderBy};`;
    const result = await this.db.query(query);

    return result;
  }


  /**
   * Retrieves the details of an electronic document (edoc) based on the provided edoc ID and user ID.
   *
   * @param {number} edoc_id - The unique identifier for the electronic document.
   * @param {number} [user_id=0] - The unique identifier for the user. Defaults to 0, and will use the instance's user_id if not provided.
   * @return {Promise<Object>} A promise that resolves to the details of the electronic document fetched from the database.
   */
  async getEdocDetails(edoc_id: number, user_id: number = 0)
  {
    if (user_id == 0) user_id = this.getUserId();

    const query = `SELECT * FROM edoc_details WHERE edoc_id = ${edoc_id} AND user_id = ${user_id};`; // WHERE category_refID = ${parent_id}
    const result = await this.db.query(query);

    return result;
  }


  /**
   * @Todo: Erweitern auf alle Tabellen und prüfen anhand von User ID
   */
  async geteDocsCount() {
    const query = `SELECT COUNT(*) as count FROM edoc;`;
    const result = await this.db.query(query);

    return result.values[0].count;
  }
}
